<script lang="ts" setup>
interface Props {
  background?: 'bg-secondary'; // update this as needed
  variant?: 'blurry' | 'solid';
  rounded?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  background: 'bg-secondary',
  variant: 'blurry',
  rounded: false,
});

const backgroundClass = computed(() => {
  return twMerge(props.background, cva('absolute inset-0', {
    variants: {
      variant: {
        blurry: 'blur-xs',
        solid: '',
      },
      rounded: {
        true: 'rounded-lg',
        false: '',
      },
    },
  })({
    rounded: props.rounded,
    variant: props.variant,
  }));
});
</script>

<template>
  <span class="relative px-1 max-w-fit inline-block">
    <span
      data-text-highlight
      :class="backgroundClass"
      aria-hidden="true"
    />
    <span class="relative z-10"><slot /></span>
  </span>
</template>
